import React from "react";
import { Container } from "./styled";
export const Button = ({ onClick, children }) => (React.createElement(Container, { onClick: onClick }, children));
